<script setup lang="ts">
import IconCheck from '@/components/Icon/Check.vue'
import IconParking from '@/components/Icon/ParkingPaid.vue'
import type { Parking } from '@/location'
import TtTurnRadius from './TtTurnRadius.vue';

defineProps<{
  parking: Parking
  available?: boolean
  disabled?: boolean
  image?: string
  as: string
  onMyBookings?: boolean
}>()
</script>

<template>
  <component
    :is="as"
    :class="`flex w-full items-center justify-between rounded border border-black/10 disabled:border-tt-lighter-gray disabled:bg-tt-lighter-gray`"
    :disabled="disabled && !onMyBookings"
  >
    <div class="flex h-[52px] items-center gap-2">
      <IconParking class="m-3 mr-0" />
      <div class="relative">
        <div class="flex items-center gap-2">
          <span class="">{{ parking.name }}</span>
          <div
            v-if="!onMyBookings"
            class="h-2 w-2 rounded-full"
            :class="available ? 'bg-tt-green' : 'bg-tt-red'"
          ></div>
          <TtTurnRadius :radius="parseInt(parking.accessibility)" :inline="true" />
        </div>
      </div>
    </div>
    <div>
      <div :class="`mr-4 flex items-center gap-1 font-mono tracking-tighter`">
        <span class="">{{ parking.price }}</span>
        <span class="text-tt-gray/50">kr</span>
        <svg
          v-if="!onMyBookings"
          class="ml-1"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="12"
          fill="none"
          viewBox="0 0 16 12"
        >
          <path
            fill="currentColor"
            d="M15.5 1.5A1.5 1.5 0 0 0 14 0H2A1.5 1.5 0 0 0 .5 1.5v9A1.5 1.5 0 0 0 2 12h12a1.5 1.5 0 0 0 1.5-1.5v-9ZM14 3H2V1.5h12V3ZM2 5.25h12v5.25H2V5.25Z"
          />
        </svg>
        <IconCheck v-if="onMyBookings" class="ml-1"></IconCheck>
      </div>
    </div>
  </component>
</template>
